import { $prose } from "@milkdown/utils"
import { Plugin, PluginKey } from "@milkdown/prose/state"

// Reports each document change as it lands. The event carries the fact of the
// change alone; a listener reads the document back off the editor when it needs
// it. Milkdown's own listener debounces, which is late enough to lose a paste to
// a navigation right after it.
//
// A microtask out of ProseMirror's update, because a listener can reach as far
// as inserting a card into the page while the caret is still being placed.
export const docChangePlugin = (onChange) =>
	$prose(() => new Plugin({
		key: new PluginKey("doc-change"),
		view: () => ({
			update(view, previous) {
				if (!view.state.doc.eq(previous.doc)) queueMicrotask(onChange)
			},
		}),
	}))
